// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-results[data-v-35a65e2c]{text-align:center;margin-top:30px;max-width:315px}.no-results h3[data-v-35a65e2c]{margin-bottom:20px;font-size:32px;font-weight:900}.no-results h4[data-v-35a65e2c]{margin-bottom:40px;font-size:22px;font-weight:700}\n", ""]);
// Exports
module.exports = exports;
